import React, { Component } from "react";
import strings from "../config/strings";
import Image from "../components/Image"
import ImageBackground from "../components/ImageBackground"
import Button from "../components/Button"
import Utils from "../utils/utils";
import {SECONDARY_COLOR} from "../config/styles";
import { BrowserRouter, Route, Switch, useRouteMatch, Link, useParams, useHistory } from 'react-router-dom';
import TitledTextInput from "../components/TitledTextInput";
import { HEADER_HEIGHT } from '../config/Constants'
import OptionList from "../components/OptionList";


import {
  ScrollView,
  View,
  TextInput,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
  Alert,
  FlatList,
  ActivityIndicator,
  Dimensions,
  Picker
} from 'react-native';

const MARGIN = 6;

const MARGIN_OUT = 6;

const { width, height } = Dimensions.get("window");
const gutter = 0;


const UNITS = [
  { id: 1, text: strings.meters, multiple:100 },
  { id: 2, text: strings.centimeters, multiple:1 },
  { id: 3, text: strings.inches, multiple:2.54},
  { id: 4, text: strings.yards , multiple: 91.44 }
];

export default class DistribStitches extends Component {
  handler = dims => this.setState(dims);

  constructor(props) {
    super(props);


    this.selectedInputType = UNITS[2]
    this.selectedOutputType = UNITS[1]
    this.input = null
    this.state = {
      output: null,
      currentnb: null,
      desirednb: null, 
      increase: false,
      answer:false,
      todo:"decrease",
      spread:"5",
      diff:"5",
    }
  }

 

     back = () => {
    this.props.navigation.goBack();
  };


giveNumberStitches(title,action) {
  return(
    <View style={{flex:1}}>
        <Text
        style={{
        alignSelf: "center",
        textAlign: "center",
        flex:1,
        color:"#555"
        }}>
        {title}
        </Text>
        <TextInput
          style={{flex:4,padding: 2, textAlign: "center", textAlignVertical:"center",fontWeight:"bold", color:'#2ba5f7', fontSize:30,borderBottomWidth:2,borderColor:"#888" }}
          keyboardType="numeric"
          
          onChangeText={text => action(text)}
          returnKeyType="done"
        />
    </View>
    )

}

takeCurrentNb = (number) => {
    if (number == "" || number == null)
      return
this.setState({currentnb:number})

}

takeDesiredNb = (number) => {
      if (number == "" || number == null)
      return
this.setState({desirednb:number})

}

validateAnswer() {
  var currentnb = this.state.currentnb;
  var desirednb = this.state.desirednb;
  if (currentnb == null && desirednb == null) {
    alert(strings.distribstitches.pleaseenter);
    return
  }
  var diff = Math.round(currentnb - desirednb) 
 
  if (diff > 0) {
    var todo = strings.distribstitches.decreases
    var minus = 1;
  } else {
    diff = diff * -1;
    var todo =strings.distribstitches.increases;
    var minus = 0;
  }
 var spread = Math.trunc(currentnb / diff) - minus;
 var remain = currentnb%diff;
 var edges = (remain + spread - minus)%2
 
 if (edges != 0 && (diff%2 == 0) && diff > 3) {
  var spread2 = spread + edges;
  var diff1 = diff/2 - 1;
  var diff3 = diff/2 - 1;
  var diff2 = 1;
  var startat = Math.round((remain + spread - minus)/2) - edges;
  this.setState({visarray:this.getVisualisationArray(startat,spread,todo,currentnb), even:false,diff1: diff1.toString(), diff3: diff3.toString(),spread:spread.toString(),diff2: diff2.toString(), spread2:spread2.toString(),answer:true, todo:todo, startat:startat.toString()})
   } else {
    var startat = Math.round((remain + spread)/2) - minus;
      this.setState({visarray:this.getVisualisationArray(startat,spread,todo,currentnb), even:true,diff: diff.toString(), spread:spread.toString(),answer:true, todo:todo, startat:startat.toString()})

   }
}

getVisualisationArray(startat,spread,todo,currentnb) {
  
  if (todo == strings.distribstitches.increases) {
    var red = [1];
    var nb = 1;
  } else {
    //startat = startat - 1;
    spread = spread - 1;
    var nb = 2; 
    var red = [1,1]}
  var array = [];
  var total = startat + (spread * 2) + (nb * 2);

  for (let i = 0; i < startat; i++) {
    array.push(0)
  }
  array = array.concat(red)
  for (let i = 0; i < spread; i++) {
    array.push(0)
  }
  array = array.concat(red)
  if (spread == 0) {
    array.push(1)
  } else {
    array.push(0)
  }
  return array
}

singularize(term, nb) {
  if (nb === 1) {
    switch(term) {
        case strings.distribstitches.increases:
          term = strings.distribstitches.increase;
          break;
        case strings.distribstitches.decreases:
          term = strings.distribstitches.decrease;
          break;
        case strings.distribstitches.stitches:
          term = strings.distribstitches.stitch;
          break;  
        default:
          break; 
      }
      
  }
   return term
}

renderAnswer(text1,answer1,answer2) {
  var nb = parseInt(answer1)
  const answer3 = this.singularize(answer2,nb);
  return (
    <View style={{flex:0, flexDirection:"row",justifyContent:"flex-start",alignItems:"center",marginVertical:10}} >
        <View style={{flex:0, marginRight:20}}>
        <Image
            style={[{alignSelf:"center",width:40,height:40 }]}
            resizeMode="contain"
            urlOnServer={"/imgs/fleche-conv-rot.png"}
            />
        </View>
        <View style={{flex:4,justifyContent:"center", alignItems:"flex-start",marginLeft:5}}>
        <Text style={{flex:1,textAlignVertical:"center", color:"#555"}}>
        {text1}
        </Text>
        <Text style={{flex:1,color:"#1B82BC",fontWeight: "bold", fontSize:16,textAlignVertical:"center"}}>
        {answer1.toUpperCase() + " " + answer3.toUpperCase()}
        </Text>
        </View>
    </View>

    )
  
}

renderStartAt(text1,todo,text2,answer1,answer2) {
  todo = this.singularize(todo,1);
  return (
    <View style={{flex:0, flexDirection:"row",justifyContent:"flex-start",alignItems:"center",marginVertical:10}} >
        <View style={{flex:0, marginRight:20}}>
        <Image
            style={[{alignSelf:"center",width:40,height:40 }]}
            resizeMode="contain"
            urlOnServer={"/imgs/fleche-conv-rot.png"}
            />
        </View>
        <View style={{flex:4,justifyContent:"center", alignItems:"flex-start",marginLeft:5}}>
        <Text style={{flex:1,textAlignVertical:"center", color:"#555"}}>
        {text1 + " " + todo + " " + text2}
        </Text>
        <Text style={{flex:1,color:"#1B82BC",fontWeight: "bold", fontSize:16,textAlignVertical:"center"}}>
        {answer1.toUpperCase() + " " + answer2.toUpperCase()}
        </Text>
        </View>
    </View>

    )
  
}
renderAnswer2(text1,answer1,answer2,every,spread,stitches) {
  var nb = parseInt(answer1)
  const answer3 = this.singularize(answer2,nb);
  var nb2 = parseInt(spread)
  const stitchesok = this.singularize(stitches,nb2);
  return (
    <View style={{flex:1, flexDirection:"row",justifyContent:"flex-start",alignItems:"center",marginVertical:10}} >
        <View style={{flex:0, marginRight:20}}>
        <Image
            style={[{alignSelf:"center",width:40,height:40 }]}
            resizeMode="contain"
            urlOnServer={"/imgs/fleche-conv-rot.png"}
            />
        </View>
        <View style={{flex:4,justifyContent:"center", alignItems:"flex-start",marginLeft:5,}}>
            <Text style={{flex:1, flexDirection:"row",justifyContent:"center",alignItems:"flex-start",color:"#555"}} >
              <Text style={{flex:0,alignItems:"flex-start",color:"#555"}}>
              {text1 + " "}
              </Text>
              <Text style={{flex:1,color:"#1B82BC",fontWeight: "bold", fontSize:16,textAlignVertical:"bottom"}}>
              {answer1.toUpperCase() + " " + answer3.toUpperCase()}
              </Text>
            </Text>
            <Text style={{flex:1, flexDirection:"row",justifyContent:"center",alignItems:"flex-start",color:"#555"}} >
              <Text style={{flex:0,alignItems:"flex-start", color:"#555"}}>
              {every + " "}
              </Text>
              <Text style={{flex:1,color:"#1B82BC",fontWeight: "bold", fontSize:16,textAlignVertical:"bottom"}}>
              {spread + " " + stitchesok.toUpperCase()}
              </Text>
            </Text>
        </View>
    </View>

    )
}
renderStitch(type){
  return (
      <View style={{paddingRight:5}}>
      {type==0?<Image
                style={[{alignSelf:"center",width:25,height:25 }]}
                resizeMode="contain"
                urlOnServer={"../imgs/maille.png"}
                />:<Image
                style={[{alignSelf:"center",width:25,height:25 }]}
                resizeMode="contain"
                urlOnServer={"../imgs/maillerose.png"}
                />}
      </View>
    )
}  
  
renderVisualisation(visarray){
  return(
    <View style={{flex:1, padding:15}} >
    <Text style={{marginBottom:5,flex:1,color:"#555"}}>{strings.distribstitches.willstart}</Text>
        <FlatList 
          horizontal={true}
          data={visarray}
          keyExtractor={(item, index) => index}
          renderItem={(item) => this.renderStitch(item.item)} >
        </FlatList>
    </View>
    )
}




  render() {

    var todo = this.state.todo;
    var spread = this.state.spread;
    var startat = this.state.startat;
    var visarray = this.state.visarray

    if (this.state.even == false) {
      var diff1 = this.state.diff1;
       var diff2 = this.state.diff2;
       var diff3 = this.state.diff3;
       
       var spread2 = this.state.spread2;
    } else {
      var diff = this.state.diff;
      
    }
    const width = Math.min(Dimensions.get("window").width / 2, 800)
    return (
        <ImageBackground urlOnServer={'/imgs/background_knitting2.jpg'}
          style={{ width:'100%', height: Dimensions.get("window").height - HEADER_HEIGHT, justifyContent:'center', alignItems:'center' }}
        >

          <View style={{ flex: 1, width:width, justifyContent:"space-between", padding:20}}>

            <View style={{ flex: 1, justifyContent: "center", alignContent: "center", paddingVertical:10 }}>
                <View
                  style={{
                    flex:2,
                    alignSelf: "center",
                    margin: 20,
                    flexDirection:"row",
                  }}
                >
                    {this.giveNumberStitches(strings.distribstitches.currentnb,this.takeCurrentNb)}
                    <Image
                      style={[{ height: 40, width: 40, alignSelf:"center", margin: 20 }]}
                      resizeMode="contain"
                      urlOnServer={"../imgs/fleche-conv-rot.png"}
                    />
                    {this.giveNumberStitches(strings.distribstitches.desirednb,this.takeDesiredNb)}
                </View>
          </View>
          <View style={{flex:1,paddingVertical:10}}>
              <Button title={"ok"} style={{alignSelf:'center'}} onPress={() => this.validateAnswer()}/>
          </View>
          
          {this.state.answer && this.state.even? <View style={{justifyContent:"center",paddingVertical:20}}>
          {this.renderAnswer(strings.distribstitches.weadvise,diff,todo)}
          {this.renderAnswer(strings.distribstitches.every,spread,strings.distribstitches.stitches)}
          {this.renderStartAt(strings.distribstitches.thefirst,todo,strings.distribstitches.after,strings.distribstitches.stitch,startat)}
          </View>:this.state.answer && <View style={{justifyContent:"center",paddingVertical:20}}>
          {this.renderStartAt(strings.distribstitches.thefirst,todo,strings.distribstitches.after,strings.distribstitches.stitch,startat)}
          {this.renderAnswer2(strings.distribstitches.then,diff1,todo, strings.distribstitches.every, spread, strings.distribstitches.stitches)}
          {this.renderAnswer2(strings.distribstitches.then,diff2,todo, strings.distribstitches.after, spread2, strings.distribstitches.stitches)}
          <Text style={{flex:1,marginLeft:15,color:"#555"}} >{strings.distribstitches.endwith}</Text>
          {this.renderAnswer2("",diff3,todo, strings.distribstitches.every, spread, strings.distribstitches.stitches)}
          
          </View>}
          
          {this.state.answer && this.renderVisualisation(visarray)}

          </View>
        </ImageBackground>
    );
  }
}

const styles = StyleSheet.create({
  toolContainer: {
    margin: MARGIN,
    shadowColor: "#000",
    shadowOpacity: 0.6,
    shadowRadius: 3,
    elevation: 8,
    backgroundColor: SECONDARY_COLOR,
    borderRadius: 8
  },
  textItem: {
    textAlign: "center",
    color: "white",
    backgroundColor: "transparent"
  }
});
